import React, { useRef, useState } from 'react';
import {Row, Col, Form} from 'react-bootstrap'
import emailjs from '@emailjs/browser';

export const FormComponent = () => {
  const [validated, setValidated] = useState(false);
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'service_awl69to', 
        'template_k1t03tl', 
        "#booking_form", 
        'Gffvzuxt0cVj3G-Fm'
        )
        .then(
          () => {
            alert("Your booking request has been received and we are excited to see you. If you do not receive a reply email from us please check your spam folder. To reschedule please call to confirm on 0212882554. - Steven and Stephanie.");
            setValidated(false);
            e.target.reset();
          },
          (error) => {
            alert("There was a problem sending your message.");
          }
        );
  };
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      sendEmail(event);
    }
    setValidated(true);
  }
  return (
    <Form className="needs-validation"
    noValidate 
    ref={form} 
    onSubmit={handleSubmit}
    validated={validated}
    id="booking_form" 
    >
  {/* First and Last Name */}
  <Row>
    <Col xs={6} sm={{span: 8, offset: 2}} md={{span: 4, offset: 2}} className="form-group">
      <label htmlFor="form-first-name" className="form-label">First Name</label>
      <input type="text" className="form-control" id="form_first_name" name="form_first_name" required />
      <div className="invalid-feedback">
        Please input your first name.
      </div>
    </Col>
    <Col xs={6} sm={{span: 8, offset: 2}} md={{span: 4, offset: 0}} className="form-group">
      <label htmlFor="form-last-name" className="form-label">Last Name</label>
      <input type="text" className="form-control" id="form_last_name" name="form_last_name" required />
      <div className="invalid-feedback">
        Please input your last name.
      </div>
    </Col>
  </Row>
  {/* Date and Time */}
  <Row>
    <Col xs={6} sm={{span: 4, offset: 2}} className="form-group">
      <label htmlFor="form-date" className="form-label">Date</label>
      <input type="date" className="form-control" id="form_date" name="form_date" required />
      <div className="invalid-feedback">
        Please input the date of your booking.
      </div>
    </Col>
    <Col xs={6} sm={4} className="form-group">
    <label htmlFor="form-select-time" className="form-label">Time</label>
      <select className="form-control" id="form_select_time" name="form_select_time" required>
        <option value={""}></option>
        <option value={"10:00am"}>10:00am</option>
        <option value={"10:30am"}>10:30am</option>
        <option value={"11:00am"}>11:00am</option>
        <option value={"11:30am"}>11:30am</option>
        <option value={"12:00pm"}>12:00pm</option>
        <option value={"12:30pm"}>12:30pm</option>
        <option value={"1:00pm"}>1:00pm</option>
        <option value={"1:30pm"}>1:30pm</option>
        <option value={"2:00pm"}>2:00pm</option>
        <option value={"2:30pm"}>2:30pm</option>
      </select>
      <div className="invalid-feedback">
        Please select a time.
      </div>
    </Col>
    <Col sm={{span: 8, offset: 2}}>
      <p>We are currently closed on Mondays, and so we are unable to accept bookings made for these dates.</p>
    </Col>
  </Row>
  {/* Number of People */}
  <Row>
  <Col xs={6} sm={{span: 4, offset: 2}} className="form-group">
    <label htmlFor="form-select-people" className="form-label">Number of People</label>
    <input pattern="[0-9]*" className="form-control" id="form_select_people" name="form_select_people" required/>
      <div className="invalid-feedback">
        Please let us know how many people are attending.
      </div>
    </Col>
    <Col sm={{span: 8, offset: 2}}>
      <p>For bookings of 4 or more people, please phone us on <a href="tel:0212882554">021 2882 554</a>, thank you.</p>
    </Col>
  </Row>  
  <Row>
    <Col className="form-group" sm={{span: 8, offset: 2}}>
    {/* Function to Book */}
      <label htmlFor="form_select_function"  className="form-label">What service would you like to book?</label>
      <select className="form-control" id="form_select_function" name="form_select_function" required>
        <option value={""}></option>
        <option value={"Table Booking"}>Table Booking</option>
        <option value={"High Tea"}>High Tea</option>
        <option value={"Functions Hosting"}>Functions Hosting</option>
        <option value={"Venue Hire"}>Venue Hire</option>
      </select>
      <div className="invalid-feedback">
        Please select a service to book.
      </div>
    </Col>
  </Row>
  {/* Email */}
  <Row>
    <Col sm={{span: 8, offset: 2}} className="form-group">
    <label htmlFor="form-email" className="form-label">Email</label>
      <input type="email" className="form-control" id="form_email" name="form_email" required />
      <div className="invalid-feedback">
        Please input your email.
      </div>
    </Col>
  </Row>
  {/* Phone Number */}
  <Row>
    <Col sm={{span: 8, offset: 2}} className="form-group">
    <label htmlFor="form-phonenumber" className="form-label">Phone Number</label>
      <input type="tel" pattern="[0-9]*" className="form-control" id="form_phonenumber" name="form_phonenumber" required/>
      <div className="invalid-feedback">
        Please input your phone number.
      </div>
    </Col>
  </Row>
  {/* Additional comments (e.g.vegetarian) */}
  <Row>
    <Col sm={{span: 8, offset: 2}} className="form-group">
    <label htmlFor="form-comments" className="form-label">If you have any dietary requirements please let us know below and we will do our best to accomodate.</label>
      <input type="tel" pattern="[A-Za-z0-9 _.,!'/$]*" className="form-control" id="form_comments" name="form_comments"/>
    </Col>
  </Row>
  {/* Submit */}
    <Col className="form-group" sm={{offset: 2}}>
      <button type="submit" className='btn btn-primary btn-submit'>SUBMIT</button>
      <div className="invalid-feedback">
        Please make sure all fields are filled before continuing.
      </div>
    </Col>
  </Form>
  );
};